export default "__VITE_ASSET__D$vZjhsx__"